// extracted by mini-css-extract-plugin
export default {"section":"login_section__+q-aK","header":"login_header__WrczL"};